// Enable debug utils in development or staging
export const isDevMode = process.env.NODE_ENV === 'development' || process.env.NUXT_ENV_CMS_DEBUG;
